import queryString from 'query-string';

export type FetchUserMetadataParameters = {
  currentUserId: number;
};

export type FetchUserMetadataResponse = {
  integratedWithRiverside: boolean;
  origin: string;
};

export async function fetchUserMetadata({
  currentUserId,
}: FetchUserMetadataParameters): Promise<FetchUserMetadataResponse> {
  const url = queryString.stringifyUrl({
    url: `/api/proxy/v3/users/${currentUserId}/metadata`,
    query: {
      userId: currentUserId.toString(),
    },
  });
  try {
    const response = await fetch(url);
    if (response.ok) {
      return await response.json();
    }
    throw new Error(`Could not fetch user metadata`);
  } catch (err) {
    throw new Error(err.message);
  }
}
